import React, { FunctionComponent } from 'react'

/**
 * CASHDAP-3954 (R4): the security badge above the remember-me step-up verify heading — the arcade
 * 32/security-lock-fill glyph on a 64px disc, exported from the approved Figma (R4 · OTP frame).
 * Inline SVG because the core Icon set has no shield-with-keyhole: bronte Guard has no arcade
 * mapping (renders null on Pegasus/Kelpie) and Lock is a different glyph. The fixed black disc /
 * white glyph is the approved treatment on every theme.
 */
export const StepUpBadge: FunctionComponent = () => (
  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true' data-testid='verify-step-up-badge'>
    <circle cx='32' cy='32' r='32' fill='black' />
    <path
      transform='translate(16 16)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.3084 5.63191L17.2483 0.57124C16.4557 0.20856 15.5445 0.20856 14.7519 0.57124L3.69184 5.6319C2.66226 6.103 1.98626 7.1097 2.01003 8.24169C2.07717 11.4383 2.54369 18.0846 5.12124 22.4001C7.52193 26.4195 12.2535 29.7073 14.6052 31.1743C15.4654 31.7109 16.5348 31.7109 17.395 31.1743C19.7467 29.7073 24.4783 26.4195 26.879 22.4001C29.4566 18.0846 29.923 11.4383 29.9902 8.24167C30.0139 7.10969 29.3379 6.103 28.3084 5.63191ZM20 13.6667C20 15.1703 19.0127 16.4625 17.6 17.0283V19.5334C17.6 20.3434 16.8837 21 16 21C15.1164 21 14.4 20.3434 14.4 19.5334V17.0283C12.9873 16.4625 12 15.1703 12 13.6667C12 11.6417 13.7909 10 16 10C18.2092 10 20 11.6417 20 13.6667Z'
      fill='white'
    />
  </svg>
)
